import {
  FETCH_SESSIONS,
  CREATE_SESSION,
  CLEAN_SESSION,
  FETCH_SESSION,
  ADD_INGREDIENT,
  DELETE_INGREDIENT,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  UPDATE_INGREDIENT,
  UPDATE_PROD_SESSION,
  UPDATE_LEFTOVER,
  FETCH_RECIPES,
  CREATE_INTERMEDIATE_LABELS,
  FETCH_SESSION_OUTPUT,
  FETCH_SESSION_DETAIL,
  FETCH_SESSION_CAN_PRODUCE,
  FETCH_STATIONS,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  sessionsList: {
    sessions: [],
    hasMore: false,
    pages: undefined,
    error: null,
    loading: true,
  },
  session: {
    session: null,
    error: null,
    loading: true,
  },
  sessionDetail: {
    session: null,
    error: null,
    loading: true,
  },
  recipeList: {
    list: [],
    loading: undefined,
    error: undefined,
  },
  sessionIntermediateLabels: {
    newLabels: [],
    printedLabels: [],
    error: null,
    loading: false,
  },
  sessionOutput: {
    output: null,
    error: null,
    loading: true,
  },
  productionSessionDetail: {
    detail: null,
    error: null,
    loading: true,
  },
  productionSessionCanProduce: {
    products: null,
    error: null,
    loading: true,
  },
  stationsList: {
    stations: [],
    error: null,
    loading: true,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_SESSIONS
    // --------------------------------------------------------------------------
    case FETCH_SESSIONS.init:
      return {
        ...state,
        sessionsList: { ...state.sessionsList, sessions: [], loading: true },
      };
    case FETCH_SESSIONS.success:
      return {
        ...state,
        sessionsList: {
          sessions: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_SESSIONS.failure:
      return {
        ...state,
        sessionsList: {
          ...state.sessionsList,
          sessions: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_SESSION
    // --------------------------------------------------------------------------
    case CREATE_SESSION.init:
      return {
        ...state,
        session: { ...state.session, error: null, loading: true },
      };
    case CREATE_SESSION.success:
      return {
        ...state,
        session: { ...state.session, session: action.payload, error: null, loading: false },
      };
    case CREATE_SESSION.failure:
      return {
        ...state,
        session: { ...state.session, session: null, error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // CLEAN_SESSION
    // --------------------------------------------------------------------------
    case CLEAN_SESSION:
      return {
        ...state,
        sessionDetail: { ...state.sessionDetail, session: null, error: null, loading: true },
      };
    // --------------------------------------------------------------------------
    // UPDATE_PROD_SESSION
    // UPDATE_INGREDIENT
    // DELETE_INGREDIENT
    // ADD_INGREDIENT
    // ADD_PRODUCT
    // DELETE_PRODUCT
    // UPDATE_PRODUCT
    // FETCH_SESSION
    // --------------------------------------------------------------------------
    case UPDATE_PROD_SESSION.init:
    case UPDATE_INGREDIENT.init:
    case DELETE_INGREDIENT.init:
    case ADD_INGREDIENT.init:
    case ADD_PRODUCT.init:
    case DELETE_PRODUCT.init:
    case UPDATE_PRODUCT.init:
    case UPDATE_LEFTOVER.init:
    case FETCH_SESSION.init:
      return {
        ...state,
        sessionDetail: { ...state.sessionDetail, error: null, loading: true },
      };
    case UPDATE_PROD_SESSION.success:
    case UPDATE_INGREDIENT.success:
    case ADD_PRODUCT.success:
    case DELETE_PRODUCT.success:
    case UPDATE_PRODUCT.success:
    case DELETE_INGREDIENT.success:
    case UPDATE_LEFTOVER.success:
    case ADD_INGREDIENT.success:
    case FETCH_SESSION.success:
      return {
        ...state,
        sessionDetail: { ...state.sessionDetail, session: action.payload, error: null, loading: false },
      };
    case UPDATE_PROD_SESSION.failure:
    case UPDATE_INGREDIENT.failure:
    case DELETE_INGREDIENT.failure:
    case ADD_PRODUCT.failure:
    case DELETE_PRODUCT.failure:
    case UPDATE_PRODUCT.failure:
    case UPDATE_LEFTOVER.failure:
    case ADD_INGREDIENT.failure:
    case FETCH_SESSION.failure:
      return {
        ...state,
        sessionDetail: {
          ...state.sessionDetail,
          error: action.payload.response ? action.payload.response.data.message : action.payload.message,
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_RECIPES
    // --------------------------------------------------------------------------
    case FETCH_RECIPES.init:
      return {
        ...state,
        recipeList: {
          list: [],
          error: undefined,
          loading: true,
        },
      };
    case FETCH_RECIPES.success:
      return {
        ...state,
        recipeList: {
          ...state.recipeList,
          list: action.payload.results,
          loading: false,
        },
      };
    case FETCH_RECIPES.failure:
      return {
        ...state,
        recipeList: {
          ...state.recipeList,
          error: action.payload.data,
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_INTERMEDIATE_LABELS
    // --------------------------------------------------------------------------
    case CREATE_INTERMEDIATE_LABELS.init:
      return {
        ...state,
        sessionIntermediateLabels: { ...state.sessionIntermediateLabels, error: null, loading: true },
      };
    case CREATE_INTERMEDIATE_LABELS.success:
      return {
        ...state,
        sessionIntermediateLabels: {
          ...state.sessionIntermediateLabels,
          newLabels: action.payload,
          printedLabels: [],
          error: null,
          loading: false,
        },
      };
    case CREATE_INTERMEDIATE_LABELS.failure:
      return {
        ...state,
        sessionIntermediateLabels: {
          ...state.sessionIntermediateLabels,
          newLabels: [],
          printedLabels: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_SESSION_OUTPUT
    // --------------------------------------------------------------------------
    case FETCH_SESSION_OUTPUT.init:
      return {
        ...state,
        sessionOutput: { ...state.sessionOutput, error: null, loading: true },
      };
    case FETCH_SESSION_OUTPUT.success:
      return {
        ...state,
        sessionOutput: { ...state.sessionOutput, output: action.payload, error: null, loading: false },
      };
    case FETCH_SESSION_OUTPUT.failure:
      return {
        ...state,
        sessionOutput: {
          ...state.sessionOutput,
          output: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_SESSION_DETAIL
    // --------------------------------------------------------------------------
    case FETCH_SESSION_DETAIL.init:
      return {
        ...state,
        productionSessionDetail: { ...state.productionSessionDetail, error: null, loading: true },
      };
    case FETCH_SESSION_DETAIL.success:
      return {
        ...state,
        productionSessionDetail: { ...state.productionSessionDetail, detail: action.payload, error: null, loading: false },
      };
    case FETCH_SESSION_DETAIL.failure:
      return {
        ...state,
        productionSessionDetail: {
          ...state.productionSessionDetail,
          detail: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_SESSION_CAN_PRODUCE
    // --------------------------------------------------------------------------
    case FETCH_SESSION_CAN_PRODUCE.init:
      return {
        ...state,
        productionSessionCanProduce: { ...state.productionSessionCanProduce, error: null, loading: true },
      };
    case FETCH_SESSION_CAN_PRODUCE.success:
      return {
        ...state,
        productionSessionCanProduce: {
          ...state.productionSessionCanProduce,
          products: action.payload.results,
          error: null,
          loading: false,
        },
      };
    case FETCH_SESSION_CAN_PRODUCE.failure:
      return {
        ...state,
        productionSessionCanProduce: {
          ...state.productionSessionCanProduce,
          products: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_STATIONS
    // --------------------------------------------------------------------------
    case FETCH_STATIONS.init:
      return {
        ...state,
        stationsList: { ...state.stationsList, stations: [], loading: true },
      };
    case FETCH_STATIONS.success:
      return {
        ...state,
        stationsList: {
          stations: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_STATIONS.failure:
      return {
        ...state,
        stationsList: {
          ...state.stationsList,
          stations: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
